<!-- Icon of a tag or format "look" (src/features/looks.ts): a FontAwesome icon in the look's colour (made readable on the current
     theme) or a user image; nothing when the look has no icon. Same markup as lookIconHtml() (src/features/looks.ts) for the HTML pieces. -->
<script setup lang="ts">
import { computed } from 'vue'
import type { TagLook } from '../data/types'
import { readableHex } from '../features/theme'
import { isLookImg } from '../features/looks'

const props = withDefaults(defineProps<{ look: TagLook; cls?: string; img?: string }>(), { cls: 'text-xs', img: 'w-4 h-4' })
const isImg = computed(() => !!props.look.icon && isLookImg(props.look.icon))
</script>

<template>
  <img v-if="isImg" :src="look.icon" alt="" :class="[img, 'rounded object-cover inline-block flex-shrink-0']">
  <i v-else-if="look.icon" :class="['fas', look.icon, cls]" :style="look.color ? { color: readableHex(look.color) } : undefined"></i>
</template>
